export default __webpack_public_path__ + "static/media/tvs-neo-nx.e918433d.svg";